// extracted by mini-css-extract-plugin
export default {"container":"ReviewFinance_container__R3k37","content":"ReviewFinance_content__LOS2y","testimony":"ReviewFinance_testimony__3hbNJ"};